/* global axios */
import ApiClient from './ApiClient';

class IxcCredentialsAPI extends ApiClient {
  constructor() {
    super('profile/ixc_credential', { apiVersion: 'v2' });
  }

  save(data) {
    return axios.patch(this.url, data);
  }

  remove() {
    return axios.delete(this.url);
  }

  verify() {
    return axios.post(`${this.url}/verify`);
  }
}

export default new IxcCredentialsAPI();
